import React, { useContext } from 'react';
import { layoutContext } from '../RAIAssessment';
import './Intro.scss';
import { Scenario } from '../../data/constants';
import { Button } from 'carbon-components-react';
import { ArrowRight20 } from '@carbon/icons-react';
import PublicImage from 'src/common/components/PublicImage';

interface introProps {
  contents: any;
}

const Intro = (introProps: introProps) => {
  const { contents } = introProps;
  const { setCurrentScenario } = useContext(layoutContext);

  return (
    <div style={{ margin: 0 }}>
      <div className="bx--row rai-assessment__intro" style={{ margin: 0 }}>
        <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4 rai-assessment__intro-content">
          <h1 className="rai-assessment__intro-headline">{contents.title}</h1>
          <h4 className="rai-assessment__intro-description">{contents.copy}</h4>
          <h4 className="rai-assessment__intro-description">
            {contents.copy2}
          </h4>
          <Button
            className="rai-assessment__intro-cta bx--btn"
            onClick={() => setCurrentScenario(Scenario.questions)}
          >
            {contents.button}
            <ArrowRight20 className="rai-assessment__intro-cta-icon" />
          </Button>
        </div>
        <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4">
          <PublicImage
            imgPath={contents.imageSrc}
            widgetId="rai-assessment"
            alt={'watson x img'}
            className="rai-assessment__intro-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Intro;
